<template>
  <div class="container">
    <BaseFrame
      :infosArr="infosArr"
      :id="id"
      :idText="idText"
      clearText=""
      :submitText="isEdit ? '' : '提交'"
      :newRecord='true'
      @hanldeLog='handleLog'
      :logData='logData'
      logText='操作日志'
      @submit='submit'
      @cancel='$router.push(-1)'
    >
      <div slot="content">
        <lk-card>
          <lk-row style="margin-bottom: 10px;">
            <lk-col span="24" class="prescriptionCol">
                <lk-tabs type="card" value="name1">
                  <span slot="extra">处方信息</span>
                  <lk-tab-pane label="处方登记" name="name1">
                    <PrescriptionRegistration
                      ref="patientInfo1"
                      v-model="salePrescription"
                      :diseaseList='diseaseList'
                      :usageList='usageList'
                      :drugTableData='drugTableData'
                      :able='able'
                    />
                  </lk-tab-pane>
                  <lk-tab-pane label="其他疾病信息" name="name2">
                    <OtherDiseaseCard
                      v-model="disease"
                      ref="patientInfo2"
                      :able='able'
                    ></OtherDiseaseCard>
                  </lk-tab-pane>
                  <lk-tab-pane label="购药者信息" name="name3">
                    <BuyerInfo
                      v-model="purchaserQo"
                      ref="patientInfo"
                      :able='able'
                    ></BuyerInfo>
                  </lk-tab-pane>
                </lk-tabs>
            </lk-col>
          </lk-row>
        </lk-card>
        <div v-if="isEdit" style='padding-top:16px'>
          <lk-card>
            <div style='padding-top:14px'>
              <lk-form :label-width="90" >
                <lk-row :gutter='16'>
                  <lk-col :span='7'>
                    <lk-form-item label='修改确认:'>
                      <div style="display:flex;justify-content: space-between">
                        <lk-input v-model="confirm.account" style="width:48%" placeholder="请输入账号"></lk-input>
                        <lk-input v-model="confirm.password" class="input-password" style="width:48%" placeholder="密码"></lk-input>
                      </div>
                    </lk-form-item>
                  </lk-col>
                  <lk-col :span='17' style="display:flex;justify-content: flex-end; ">
                    <lk-button class="mr8" @click="confirm={}">重置</lk-button>
                    <lk-button type='primary'  @click="handleToken">提交修改</lk-button>
                  </lk-col>
                </lk-row>
              </lk-form>
            </div>
          </lk-card>
        </div>
      </div>
    </BaseFrame>
  </div>
</template>

<script>
import BaseFrame from '../../components/frame/BaseFrame.vue';
import PrescriptionRegistration from '../../components/prescription/PrescriptionRegistration.vue';
import OtherDiseaseCard from '../../components/prescription/OtherDiseaseCard.vue';
import BuyerInfo from '../../components/prescription/BuyerInfo.vue';
import sale from '../../services/sale';
import goods from '../../services/goods';
import system from '../../services/system';
import utils from '../../libs/utils';

export default {
  name: 'PharmaceuticalSaleInfo',
  components: {
    BaseFrame,
    BuyerInfo,
    OtherDiseaseCard,
    PrescriptionRegistration,
  },
  watch: {
  },
  data() {
    return {
      id: '',
      idText: '处方ID',
      isEdit: false,
      able: true,
      confirm: {},
      infosArr: [],
      genderList: {
        1: '男',
        2: '女',
      },
      saleUsageList: [],
      diseaseList: [],
      salePrescription: {}, // 处方信息
      usageList: [], // 编辑处方商品
      disease: {}, // 其他疾病信息
      purchaserQo: {}, // 购药者信息
      diseaseInfo: [],
      drugTableData: [],
      logData: [], // 操作日志
    };
  },
  computed: {
  },
  methods: {
    submit(token) {
      // 校验三个组件的form
      this.$refs.patientInfo2.validateForm();
      let valid1 = false;
      let valid2 = false;
      this.$refs.patientInfo.validateForm().then((valid) => {
        valid1 = valid;
      });
      this.$refs.patientInfo1.validateForm().then((valid) => {
        valid2 = valid;
        if(valid1 && valid2){
          let storeTable = this.$store.getters.getPrescriptionTableData;
          let electronicPrescriptionUsage = [];
          storeTable.forEach(item => {
            electronicPrescriptionUsage.push({
              goodsBaseId: item.goodsBaseId || item.id,
              approvedName: item.approvedName || '',
              spec: item.spec || '',
              num: item.num || '',
              usageType: item.usageType || '',
              usageName: item.usageName || '',
              frequency: item.frequency || '',
              frequencyName: item.frequencyName || '',
              dosage: item.dosage || '',
              startTime: item.startTime || '',
              usageCycle: item.usageCycle || '',
              remindDays: item.remindDays || '',
            })
          })
          const params = {
            prescription: {
              ...this.salePrescription,
              id: this.salePrescription.epId || '',
            },
            entry: true,
            purchaserQo: this.purchaserQo,
            diseaseQo: this.disease,
            electronicPrescriptionUsage,
            prescription_finish_token: token || null,
          }
          goods.addOrEditPrescription(params).then((res) => {
            if (res.data.status === 200) {
              this.$router.push({ name: 'prescriptionList' });
            } else {
              this.$Message.error(res.data.error);
            }
          }).catch((err) => {
            utils.handleError(err);
          });
        }
      });
    },
    getRecipeInfo(prescriptionId) {
      sale.getRecipeInfo({
        prescriptionId, encrypt: !this.able,
      }).then((res) => {
        if (res.data.status === 200) {
          const {
            data,
          } = res.data;
          this.id = data.salePrescription.id.toString();
          const infosArr = [{
            name: '销售订单号:',
            value: data.salePrescription.orderNo,
          }, {
            name: '药师:',
            value: data.salePrescription.createUserName,
          }, {
            name: '创建时间:',
            value: utils.exchangeTimeToSecond(data.salePrescription.createTime),
          }, {
            name: '订单来源:',
            value: data.saleOrder.epSourceTypeName,
          }];
          infosArr.forEach((item) => {
            this.infosArr.push(item);
          });
          this.salePrescription = data.salePrescription;
          this.salePrescription.doctor = data.salePrescription.prescriptionDoctor;
          this.salePrescription.hospital = data.salePrescription.prescriptionHospital;
          this.salePrescription.diseaseRemark = data.salePrescription.additionalRemark;
          this.salePrescription.prescriptionContact = data.salePrescription.contact;
          this.salePrescription.prescriptionContactPhone = data.salePrescription.contactPhone;
          const { provinceId, cityId, countyId } = data.salePrescription;
          this.$set(this.salePrescription, 'patientUsualResidence', [ provinceId, cityId, countyId ]);
          this.salePrescription.locationArr = [
            provinceId, cityId, countyId,
          ];
          const { provinceName, cityName, countyName } = data.salePrescription;
          this.salePrescription.locationString = countyName ? `${provinceName}/${cityName}/${countyName}` : '';
          this.disease = data.disease || {};
          this.purchaserQo = data.purchaser || {};
          data.saleGoodsDetailList.forEach(item => {
            let result = item.saleOrderDetail;
            result.isRx = 1;
            this.drugTableData.push(result);
          })
          data.saleUsageVoList.forEach(item => {
            const result = utils.deepClone(item.saleUsage);
            result.approvedName = result.approvedDrugNames;
            result.spec = item.goodsInfoVo.spec; // 规格
            result.num = result.goodsCount; // 数量
            result.startTime = result.usageStartTime; // 开始用药时间
            result.usageCycle = result.medicationCycle; // 用药周期
            result.remindDays = result.rebuyRemindDays; // 提醒时间
            result.usageName = result.goodsUsage;
            result.dosage = result.usageDosage;
            this.usageList.push(result);
          });
          this.$store.commit('setTableData', this.usageList);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getDiseaseList() {
      return new Promise((resolve) => {
        sale.getDiseaseInfo().then((res) => {
          if (res.data.status === 200) {
            this.diseaseList = res.data.data;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    handleLog() {
      this.logData = [];
      sale.getEditLog({
        bizType: 1,
        bizId: this.id,
      }).then((res) => {
        if (res.data.status === 200) {
          this.logData = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleToken() {
      if (!this.confirm.account || !this.confirm.password) {
        this.$Message.error('请输入用户名和密码');
        return;
      }
      system.PrescriptionFinishToken(this.confirm).then((res) => {
        if (res.data.status === 200) {
          this.submit(res.data.data);
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleEdit(token) {
      const temp = this.handleParams();
      console.log(temp);
      if (temp) {
        temp.prescription_finish_token = token;
        sale.editPrescription(temp).then((res) => {
          // console.log(this.saleData);
          if (res.data.status === 200) {
            this.$Message.success('修改成功');

            this.$router.push({
              name: 'recipeSalesRecord',
            });
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }
    },
  },
  created() {
    Promise.all([
      this.getDiseaseList(),
    ])
      .then(() => {
        this.getRecipeInfo(this.$route.params.id);
      });
    if (this.$route.name == 'viewPharmaceuticalSales') {
      this.able = false;
    } else if (this.$route.name == 'modifyPharmaceuticalSales') {
      this.isEdit = true;
    }
  },
};

</script>

<style scoped lang='less'>
.prescriptionCol {
    /deep/ .ivu-tabs-nav-right {
      float: left;
      margin-right: 50px;
      color: #172333;
      padding-top: 4px;
    }
  }
</style>
